module.exports = __webpack_public_path__ + "assets/facebook-blue-1faae0.svg";